import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ExpensesAction } from "./ExpensesAction";
import { formatMoney } from "../../hooks/formatMoney";
import i18next from "i18next";

const ExpensesListItem = ({ index, item, refreshHandler, tenant, taxTypeById }) => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const date = new Date(item?.expense_date);
  const formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Riyadh",
  }).format(date);
  const goToEditReadOnly = () => {
    navigate(`/${tenant}/expenses/edit/${item.id}?readonly=1`);
  };

  const validTaxes = useMemo(() => {
    if (!item?.details?.length) return [];
    const map = taxTypeById || {};
    return (
      item.details
        ?.map((detail) => {
          const tax = map[String(detail?.tax_type)];
          if (!tax) return null;
          return {
            label: String(tax.label || "").trim(),
            value: Number(tax.value),
          };
        })
        .filter(Boolean)
        .filter((tax, _, all) => {
          if (all.length === 1) return true;
          return tax.value > 0;
        })
        .map((tax) => tax.label) || []
    );
  }, [item, taxTypeById]);

  if (!item) return null;
  const noTaxLabel = i18next.language === "ar" ? "لا يوجد" : "None";
  return (
    <div className="divide-y w-full relative bg-[#ffffff] divide-[#ddd0bf] border-b border-[#ddd0bf] border-opacity-30">
      <div
        onClick={goToEditReadOnly}
        key={index}
        className="flex w-full hover:bg-[#F5F8F1] transition cursor-pointer hover:text-black gap-1 items-center py-0.5 px-1 text-[#261759] text-sm"
      >
        <div className="w-[110px] shrink-0 text-start ps-2">{item?.code}</div>
        <div className="flex-[1.6] min-w-[280px] text-start">
          {item?.desc
            ? `${(item?.desc).slice(0, 70)}...`
            : t("Salaries.nonbondDescription")}
        </div>
        <div className="w-[135px] shrink-0 text-center">
          {formatMoney(item?.total_amount)} {t("Salaries.currency")}
        </div>
        {/* <div className="w-52 text-center">
          {item?.vendor_name}
          </div> */}
        <div
          className={`flex-[1.1] min-w-[220px] text-center leading-4 whitespace-pre-line ${
            validTaxes.length === 1 ? "text-[13px]" : "text-[11px]"
          }`}
        >
          {validTaxes.length > 0 ? (
            validTaxes.map((label, i) => <div key={i}>{label}</div>)
          ) : (
            noTaxLabel
          )}
        </div>
        <div className="w-[95px] shrink-0 text-center">
          {formatMoney(item?.vat_amount)} {t("Salaries.currency")}
        </div>
        <div className="w-[135px] shrink-0 text-center">
          {formatMoney(item?.total_amount_with_vat)} {t("Salaries.currency")}
        </div>
        <div className="w-[122px] shrink-0 text-center">{formatted}</div>
        <div
          onClick={(e) => e.stopPropagation()}
          className="w-[96px] shrink-0 p-0 text-center text-[12px] rounded-md"
        >
          <ExpensesAction
            id={item.id}
            item1={t("dropdown.show")}
            path1={`/expenses/show`}
            path2={`/expenses/edit`}
            icon1={"/assets/icons/Print.png"}
            icon2={"/assets/icons/Edit.png"}
            icon3={"/assets/icons/Trash.png"}
            refreshHandler={refreshHandler}
            Path={"expenses"}
          />
        </div>
      </div>
    </div>
  );
};

export default ExpensesListItem;
